import { TooltipComponent } from 'components/tooltip-component/tooltip-component';
import styled from 'styled-components';

export const StyledLabelTooltip = styled(TooltipComponent)`
  margin-right: 5px;
`;
